import TableCell from '@mui/material/TableCell'
import { styledWithBreakpoints } from 'src/Utils/styled'

export const TableCellPeriod = styledWithBreakpoints(TableCell, '150px', '140px')
